import { Input } from "design-system/atoms/Input"
import { cn } from "design-system/utils"
import { LucideIcon } from "lucide-react"
import { useDebouncedValue } from "modules/shared/hooks/useDebouncedValue"
import { useState } from "react"
import { useTranslation } from "react-i18next"

type SearchQueryProps = {
  placeholder?: string
  setQuery: (query: string) => void
  defaultValue?: string
  icon?: LucideIcon
  className?: string
  disabled?: boolean
}

export function SearchQuery({
  placeholder,
  setQuery,
  defaultValue = "",
  icon,
  className,
  disabled,
}: SearchQueryProps) {
  const { t } = useTranslation()
  const [internalQuery, setInternalQuery] = useState<string>(defaultValue)

  useDebouncedValue({
    value: internalQuery,
    callback: (val) => setQuery(val),
  })

  return (
    <Input
      defaultValue={defaultValue}
      onChange={(e) => setInternalQuery(e.target.value)}
      placeholder={placeholder ?? t("shared.searchQuery.placeholder")}
      className={cn("min-w-40", className)}
      icon={icon}
      disabled={disabled}
    />
  )
}
